/* eslint-disable no-nested-ternary */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@type/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.app || initialState;

export const selectApp = createSelector(
  [selectDomain],
  dashboardState => dashboardState,
);

export const selectIsLoading = createSelector(
  [selectDomain],
  state => state.loading,
);

export const selectIsError = createSelector(
  [selectDomain],
  state => state.error,
);

export const selectIsSuccess = createSelector(
  [selectDomain],
  state => state.success,
);

export const selectPortfolio = createSelector(
  [selectDomain],
  state => state.portfolio || undefined,
);

export const selectPortfolioMode = createSelector(
  [selectPortfolio],
  state => state?.mode || undefined,
);

export const selectHeaderStyle = createSelector(
  [selectPortfolio],
  state => state?.headerStyle || undefined,
);

export const selectFooterStyle = createSelector(
  [selectPortfolio],
  state => state?.footerStyle || undefined,
);

export const selectCardProjectStyle = createSelector(
  [selectPortfolio],
  state => state?.cardProjectStyle || undefined,
);

export const selectMenuCollectionSelected = createSelector(
  [selectDomain],
  state => state.menuCollectionSelected,
);

export const selectCollectionPortfolioSelected = createSelector(
  [selectPortfolio, selectMenuCollectionSelected],
  (portfolio, menuCollectionSelected) => {
    const menu = portfolio
      ? portfolio?.menu.find(item => item.id === menuCollectionSelected)
      : undefined;
    const collection = menu
      ? portfolio.collections.find(item => item.id === menu.collection)
      : undefined;
    return collection;
  },
);
